import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store';

export type ThemeType = 'light' | 'dark';

export type ViewType = 'list' | 'grid';

export type ModalType = {
    type: string;
    id?: string;
    addTask?: boolean;
};

export interface LayoutState {
    theme: ThemeType;
    view: ViewType;
    projectsReorder: boolean;
    modal: ModalType | null;
    addingProjectBottom: boolean;
    addingProjectTop: boolean;
}

const getInitialView = (): ViewType => {
    if (typeof window !== 'undefined') {
        const savedView = localStorage.getItem('hustleView');
        return (savedView === 'grid' || savedView === 'list') ? savedView as ViewType : 'list';
    }
    return 'list';
};

const initialState: LayoutState = {
    theme: 'light',
    view: getInitialView(),
    projectsReorder: false,
    modal: null,
    addingProjectBottom: false,
    addingProjectTop: false,
};

const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        setTheme: (state, action) => {
            state.theme = action.payload;
        },
        changeTheme: (state) => {
            state.theme = state.theme === 'light' ? 'dark' : 'light';
        },
        setView: (state, action) => {
            state.view = action.payload;
        },
        changeView: (state) => {
            state.view = state.view === 'list' ? 'grid' : 'list';
        },
        setProjectsReorder: (state, action) => {
            state.projectsReorder = action.payload;
        },
        setAddingProjectBottom: (state, action) => {
            state.addingProjectBottom = action.payload;
        },
        setAddingProjectTop: (state, action) => {
            state.addingProjectTop = action.payload;
        },
        toggleprojectsReorder: (state) => {
            state.projectsReorder = !state.projectsReorder;
        },
        openModal: (state, action) => {
            state.modal = action.payload;
        },
        closeModal: (state) => {
            state.modal = null;
        },
    },
});

export const {
    setTheme,
    changeTheme,
    setView,
    changeView,
    setProjectsReorder,
    toggleprojectsReorder,
    openModal,
    closeModal,
    setAddingProjectBottom,
    setAddingProjectTop,
} = layoutSlice.actions;

export const selectLayout = (state: RootState) => state.layout;

export const selectModal = (state: RootState) => state.layout.modal;

export default layoutSlice.reducer;
